import React from 'react';
import MissingField from '../../@communityshare/ui/alerts/MissingField';

export default function OfferMissingField(props) {
  const { name } = props;

  return (
    <MissingField
      name={name}
      description={(
        <>
          Field must be provided before partner can connect with educators, or
          before the offer will be shown to others.
        </>
      )}
    />
  );
}
